'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';

// Import JS Modules
import FlyoutSection from './flyout-section';
import Wrapper from './wrapper';
import {
  href,
  link_classes,
  link_flags,
  megamenu_wrapper,
  handleFlyoutMoreClick,
  handleTopLevelKeyPress,
  handleFlyoutKeypress,
  useSupportsHover,
} from './utils';

const Flyout = (props) => {
  const supportsHover = useSupportsHover();
  const dropdownStyle = {};
  if (props.positionLeft) dropdownStyle.left = props.positionLeft;
  if (props.positionRight) dropdownStyle.right = props.positionRight;

  let $sublinks = (props.links.sublinks || []).map((sublink, i) => {
    if (megamenu_wrapper(sublink)) {
      return <Wrapper key={sublink.name + i} section={sublink} />;
    }
    return (
      <li
        key={sublink.name + i}
        className={classNames('megamenu-sub-menu', link_classes(sublink))}>
        <FlyoutSection section={sublink} />
      </li>
    );
  });

  return (
    <li
      className={classNames(
        'nav-item mega dropdown',
        link_classes(props.links),
        { show: props.active, 'd-none': props.hidden },
      )}
      onMouseEnter={supportsHover ? props.onMouseEnter : undefined}
      onMouseLeave={supportsHover ? props.onMouseLeave : undefined}>
      <a className="nav-link dropdown-toggle" href={href(props.links)}>
        {props.links.name}
        {link_flags(props.links)}
      </a>
      <button
        className={classNames('border-0 bg-white nav-item-more px-1', {
          show: props.active,
        })}
        onClick={(event) => handleFlyoutMoreClick(event, props)}
        onKeyDown={(event) => handleTopLevelKeyPress(event, props)}
        aria-expanded={props.active ? 'true' : 'false'}
        aria-label={`Show submenu of ${props.links.name}`}
        aria-haspopup="true"></button>
      <div
        className={classNames('dropdown-menu', { show: props.active })}
        style={dropdownStyle}>
        <a
          className="link-title"
          href={href(props.links)}
          onKeyDown={(event) => handleFlyoutKeypress(event, props)}>
          {props.links.name}
        </a>
        <ul
          className="list-unstyled columns"
          onKeyDown={(event) => handleFlyoutKeypress(event, props)}>
          {$sublinks}
        </ul>
      </div>
    </li>
  );
};

export default Flyout;
